import React, { useState } from 'react';
import { Home, SquarePen } from 'lucide-react';
import StoreForm from 'features/company/components/stores/StoreForm';
import DocsList from 'features/docs/components/DocsList';
import { Tabs, Tab } from 'shared/ui/Tabs';
import SnapsList from 'features/stats/components/snaps/SnapsList';
import DocStats from 'features/stats/pages/DocStats';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';

const StoreItem = ({ item }) => {
  const { openModal } = useLayout();
  const { currentColor } = useStateContext();

  const handleEditStore = () => {
    openModal({
      component: <StoreForm store={item} />,
      title: 'Изменить сотрудник',
    });
  };

  return (
    <>
      {/* Header Section */}
      <div className='flex justify-between items-start mb-6'>
        <div>
          <h1 className='text-xl font-semibold mb-1'>{item.name}</h1>
          <p className='text-gray-500 text-xs'>Создан {item.created}</p>
        </div>
        <div className='text-right'>
          <button className=' text-white px-4 py-2 rounded-md hover:' style={{ backgroundColor: currentColor }} onClick={() => handleEditStore()}>
            <SquarePen size={16} className='mr-1' />
          </button>
        </div>
      </div>

      {/* Contacts Section */}
      <div className='bg-white rounded-lg shadow-sm border mb-6'>
        <div className='p-4 border-b'>
          <h2 className='font-medium text-sm'>Адрес</h2>
        </div>
        <div className='p-4'>
          <div className='flex items-center gap-2'>
            <Home size={16} className='text-gray-500' />
            <p className='text-blue-600 text-sm'>
              {item.address && item.address.meta.name}
            </p>
          </div>
        </div>
      </div>

      {/* Recent Operations Section */}
      <div className='bg-white rounded-lg shadow-sm border'>
        <Tabs initialTab='stats'>
          <Tab key='stats' label='Статистика'>
            <DocStats from_store={item.meta} className='text-xs' />
          </Tab>
          <Tab key='outgoing_docs' label='Исходящие документы'>
            <DocsList from_store={item.meta} className='text-xs' />
          </Tab>
          <Tab key='incoming_docs' label='Приходящие документы'>
            <DocsList to_store={item.meta} className='text-xs' />
          </Tab>
          <Tab key='snaps' label='Снимки остатков'>
            <SnapsList store={item.meta} className='text-xs' />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default StoreItem;